'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaRedditSquare = function FaRedditSquare(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24 25.2q0.3 0.3 0 0.6-1.2 1.2-3.9 1.2t-3.8-1.2q-0.3-0.3 0-0.6 0.1-0.1 0.3-0.1t0.3 0.1q0.9 0.9 3.2 0.9t3.3-0.9q0.1-0.1 0.3-0.1t0.3 0.1z m-5.9-3.5q0 0.7-0.5 1.2t-1.2 0.5-1.2-0.5-0.5-1.2q0-0.7 0.5-1.2t1.2-0.5 1.2 0.5 0.5 1.2z m7.5 0q0 0.7-0.5 1.2t-1.2 0.5-1.2-0.5-0.5-1.2q0-0.7 0.5-1.2t1.2-0.5 1.2 0.5 0.5 1.2z m4.8-2.3q0-0.9-0.6-1.6t-1.7-0.7q-0.9 0-1.6 0.7-2.5-1.7-6-1.8l1.3-5.4 3.8 0.9q0 0.7 0.5 1.2t1.2 0.4q0.7 0 1.2-0.5t0.5-1.2-0.5-1.2-1.2-0.5q-1.1 0-1.6 1l-4.2-1q-0.4-0.1-0.4 0.3l-1.4 6q-3.4 0.1-5.9 1.9-0.7-0.8-1.6-0.8-1 0-1.7 0.7t-0.6 1.6q0 0.7 0.3 1.2t0.9 0.9q-0.1 0.6-0.1 1.1 0 2.7 2.7 4.6t6.5 2q3.8 0 6.4-2t2.7-4.6q0-0.6-0.1-1.1 0.5-0.3 0.9-0.9t0.3-1.2z m6.9-10.1v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
        )
    );
};

exports.default = FaRedditSquare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/reddit-square.js
// module id = 1029
// module chunks = 168707334958949